<template>
  <b-container class="page">
    <b-row class="mt-2" v-if="err">
      <b-col cols="12" style="min-height: 80%"/>
    </b-row>

    <b-row v-else-if="contentShare && contentShare.content" class="my-3 mx-0">
      <b-col
        class="d-flex flex-column justify-content-start align-items-center"
        cols="12"
        sm="10"
        offset-sm="1"
        lg="8"
        offset-lg="2"
      >
        <template v-if="logo">
          <img height="60" width="auto" :src="logo" alt="Home" />
          <hr v-if="logo" class="w-100" />
        </template>
        <template v-if="Array.isArray(jobs) && jobs.length && !isEY && !isOptiverInterns">
          <b-row class="w-100">
            <b-col cols="9" class="px-2 h-100 d-flex justify-content-start align-items-center">
              <h4 class="m-0">{{ $t('shareshow.interested') }}</h4>
            </b-col>
            <b-col cols="3" class="d-flex justify-content-end align-items-center">
              <b-btn @click="$scrollTo('#jobList')" variant="primary">{{ $t('shareshow.see-jobs') }}</b-btn>
            </b-col>
          </b-row>
          <hr class="w-100"/>
        </template>
        <div class="content-share-content w-100">
          <h2 v-if="contentShare.title" class="mb-4 mt-2">{{ contentShare.title }}</h2>
          <div v-if="!hideTopImage && ((contentShare.image && contentShare.image.fileLocation) || contentShare.imageURL)"
            class="mb-3 d-flex justify-content-center align-items-center" style="background: #444">
              <img v-if="contentShare.image && contentShare.image.fileLocation" style="max-height: 300px"
                :src="contentShare.image.fileLocation" :alt="contentShare.title"/>
              <img v-else-if="contentShare.imageURL" style="max-height: 300px"
                :src="contentShare.imageURL" :alt="contentShare.title"/>
          </div>
          <rich-text-content class="mb-4" :value="contentShare.content"/>
        </div>
      </b-col>

      <!-- Jobs Section -->
      <b-col id="jobList" v-if="Array.isArray(jobs) && jobs.length && !isEventsSite && !isOptiverInterns"
        cols="12" sm="10" offset-sm="1" lg="8" offset-lg="2">
          <b-row>
            <b-col class="pl-2">
              <h3 v-if="!isEY">{{ $t('shareshow.current-openings') }}</h3>
            </b-col>
          </b-row>

          <!-- div>
            <filter-jobs-where />
          </div -->

          <b-row class="mb-4">
            <b-col v-for="job in filterAllJobs.slice((currentPage - 1) * perPage, currentPage * perPage)" :key="job.id" cols="12" md="6" class="p-2">
              <b-card class="p-0 mb-3 h-100" body-class="px-3" footer-class="bg-primary-a1 border-0 p-2">
                <div class="d-flex flex-row justify-content-start align-items-start pb-4">
                  <h4 class="flex-fill m-0"><a :href="createJobShareUrl(job)" target="_blank">{{ job.title }}</a></h4>
                </div>
                <key-stats class="w-100" :job="job" :isPublic="true"/>
                <div v-if="job.excerpt" class="my-2">{{ job.excerpt }}</div>
                <template v-slot:footer>
                  <div class="d-flex flex-row justify-content-end align-items-center">
                    <b-btn size="sm" variant="link" :href="createJobShareUrl(job)" target="_blank">{{ $t('ctas.learn-more') }}</b-btn>
                  </div>
                </template>
              </b-card>
            </b-col>
          </b-row>
          <b-pagination
            v-model="currentPage"
            :total-rows="(filterAllJobs && Array.isArray(filterAllJobs) ? filterAllJobs.length : 0)"
            :per-page="perPage"
            align="center"
          />
      </b-col>

    </b-row>

    <b-row v-else>
      <b-col cols="12" sm="6" offset-sm="3" lg="4" offset-lg="4">
        <div v-if="contentShare && !contentShare.content">
          <p class="text-center">{{ $t('contentShares.redirecting-to', { url: '' }).trim() }}</p>
          <content-card :entry="contentShare" hide-footer/>
        </div>
        <div v-else>
          <p class="text-center">{{ $t('general.loading') }}</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import qs from 'querystring';
import Page from '@/components/Page';
import HeaderMinimal from '@/components/Header-minimal';
import ContentSharePublicQuery from '@/graphql/queries/ContentSharePublic.gql';
import FilterJobsWhere from '@/components/campaign/FilterJobsWhere';
import ContentSharePublicJobsQuery from '@/graphql/queries/ContentSharePublicJobs.gql';
import ContentCard from '@/components/content-share/ContentCard';
import KeyStats from '@src/components/jobs/key-stats';
import cdnTransform from '@/filters/cdn';
import { RichTextContent } from '@/components/RichTextField';
import { captureLog } from '@/lib/logs';
import { mapRoot, mapPreferences } from '@/mixins/root';

export default {
  props: {
    shareCode: String,
    eventID: String,
    trackingCode: String
  },
  components: {
    Page,
    HeaderMinimal,
    ContentCard,
    KeyStats,
    RichTextContent,
    FilterJobsWhere
  },
  data: () => ({
    err: null,
    user: null,
    searchTerm: null,
    perPage: 4,
    currentPage: 1,
  }),
  apollo: {
    contentShare: {
      query: ContentSharePublicQuery,
      variables() {
        const { shareCode } = this;
        return { shareCode };
      },
      update({ company }) {
        const { contentShare } = company || {};
        return contentShare;
      },
      result({ loading, data }) {
        if (!loading && data && data.company) {
          if (data.company.user && data.company.user.id) {
            this.user = data.company.user;
          }
          if (process.env.VUE_ENV === 'client') {
            if (this.contentShare) {
              this.trigger();
            }
          }
        }
      },
      error(err) {
        this.err = err;
      },
      prefetch: true,
    },
    jobs: {
      query: ContentSharePublicJobsQuery,
      variables() {
        const { contentShare, user, eventID, isCampaignsEnabled } = this;
        const { relatedJobs, relatedJobSegment } = contentShare || {};
        const whereSegment = relatedJobs === 'SEGMENTED_JOBS' && relatedJobSegment ? JSON.parse(relatedJobSegment) : {};
        const where = {
          status: 'ACTIVE',
          ...whereSegment
        };
        let campaignID = null;
        if (this.$route && this.$route.query && this.$route.query.c && !Object.keys(whereSegment).length) {
          campaignID = this.$route.query.c;
        }
        if (this.isGWRReferrals && !Object.keys(whereSegment).length) {
          campaignID = '01HFBXNPRG9BFJCD97KSFSMWFX';
        }
        if (this.isERM && !Object.keys(whereSegment).length) {
          campaignID = '01J14QNS5B5Z704Q01TGD5JG6A';
        }
        return {
          contentShareID: contentShare.id,
          userID: user.id,
          withCampaigns: isCampaignsEnabled,
          withEvent: Boolean(eventID),
          eventID,
          withSpecificCampaign: !!campaignID,
          campaignID,
          where
        };
      },
      update({ company }) {
        const { contentShare, event, jobs, campaign } = company || {};
        const { relatedJobs } = contentShare || {};
        if (Array.isArray(jobs) && jobs.length && relatedJobs === 'SEGMENTED_JOBS') {
          return jobs;
        } else if (event && Array.isArray(event.jobs) && event.jobs.length) {
          return event.jobs;
        } else if (campaign && Array.isArray(campaign.jobs) && campaign.jobs.length) {
          return campaign.jobs;
        } else {
          const campaigns = contentShare && Array.isArray(contentShare.campaigns) ? contentShare.campaigns : [];
          const campaignJobs = campaigns.reduce((js, { jobs }) => js.concat(jobs.filter(j1 => !js.find(j2 => j1.id === j2.id))), []);
          return Array.isArray(campaignJobs) && campaignJobs.length ? campaignJobs : (jobs || []);
        }
      },
      error(err) {
        this.err = err;
      },
      skip() {
        const { contentShare, user, eventID, isCampaignsEnabled } = this;
        return !(contentShare && contentShare.id && user && user.id && (eventID || isCampaignsEnabled));
      },
    },
  },
  beforeMount() {
    if (this.isEXPD8 &&
    navigator.geolocation &&
    (!sessionStorage.getItem('latitude') ||
    !sessionStorage.getItem('longitude'))) {
      navigator.geolocation.getCurrentPosition(
        position => {
          sessionStorage.setItem('latitude', position.coords.latitude);
          sessionStorage.setItem('longitude', position.coords.longitude);
        },
        () => { console.warn('Geolocation failed'); });
    }
  },
  metaInfo() {
    const head = {
      title: this.$t('contentShares.redirecting-to', { url: '' }).trim(),
      meta: [
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      ],
      links: [],
    };

    if (this.company && ((this.company.siteBranding && this.company.siteBranding.name) || this.company.name)) {
      const companyName = (this.company.siteBranding && this.company.siteBranding.name) || this.company.name;

      head.meta.push({ vmid: 'author', name: 'author', content: companyName });
      head.meta.push({ vmid: 'og:author', name: 'og:author', content: companyName });
      head.meta.push({ vmid: 'og:site_name', property: 'og:site_name', content: companyName });
      // twitter:site => @reallinksio
    }

    if (this.$root && this.$route && this.$root.origin && this.$route.path) {
      const content = `${this.$root.origin}${this.$route.path}`;
      head.links.push({ rel: 'canonical', href: content });
      head.meta.push({ vmid: 'og:url', property: 'og:url', content });
    }

    if (this.contentShare && this.contentShare.id) {
      const { title, excerpt, description } = this.contentShare;
      if (title) {
        head.title = title;
        head.meta.push({ vmid: 'og:title', property: 'og:title', content: title });
        head.meta.push({ vmid: 'twitter:title', property: 'twitter:title', content: title });
      }

      if (description && typeof description === 'string') {
        head.meta.push({ vmid: 'description', property: 'description', content: description });
        head.meta.push({ vmid: 'og:description', property: 'og:description', content: description });
      } else if (excerpt && typeof excerpt === 'string') {
        head.meta.push({ vmid: 'description', property: 'description', content: excerpt });
        head.meta.push({ vmid: 'og:description', property: 'og:description', content: excerpt });
      }

      if (this.ogImage) {
        const content = `${this.$root.origin}${cdnTransform(this.ogImage, 'resize', 1200, 627)}`;

        head.meta.push({ vmid: 'og:image', name: 'image', property: 'og:image', content });
        head.meta.push({ vmid: 'twitter:image', name: 'twitter:image', content });

        head.meta.push({ vmid: 'og:image:width', property: 'og:image:width', content: 1200 });
        head.meta.push({ vmid: 'og:image:height', property: 'og:image:height', content: 627 });

        if (title) {
          head.meta.push({ vmid: 'og:image:alt', property: 'og:image:alt', content: title });
          head.meta.push({ vmid: 'twitter:image:alt', property: 'twitter:image:alt', content: title });
        }
      }

      // Since we're about to redirect to a content URL, set a suitable Referrer-Policy
      head.meta.push({ vmid: 'referrer', name: 'referrer', content: 'unsafe-url' });

      // article:modified_time -> updated at?
      // article:expiration_time -> expiry time?
    }

    return head;
  },
  computed: {
    ...mapRoot([ 'company', 'origin', 'isEventsSite', 'isInforma', 'isTaylorAndFrancis', 'isThales', 'isEY', 'isEXPD8', 'isOptiverInterns', 'isAssurant', 'isGWRReferrals', 'isERM' ]),
    ...mapPreferences([ 'isCampaignsEnabled' ]),
    filterAllJobs() {
      if (!this.jobs || !Array.isArray(this.jobs)) {
        return [];
      }
      if (this.searchTerm === null || this.searchTerm === '') {
        return this.jobs;
      } else {
        const enteredSearchTerm = this.searchTerm.trim().toLowerCase();
        return this.jobs.filter(job => {
          return job.title.trim().toLowerCase().includes(enteredSearchTerm);
        });
      }
    },
    logo() {
      const { siteBranding: { bigLogo, smallLogo } } = this.company || {};
      if (bigLogo && bigLogo.fileLocation) {
        return bigLogo.fileLocation;
      } else if (smallLogo && smallLogo.fileLocation) {
        return smallLogo.fileLocation;
      }
      return null;
    },
    ogImage() {
      const { image, imageURL } = this.contentShare || {};
      const { siteBranding: { bigLogo, socialImage } } = this.company || {};
      if (image && image.fileLocation) {
        return image.fileLocation;
      } else if (imageURL) {
        return imageURL;
      } else if (socialImage && socialImage.fileLocation) {
        return socialImage.fileLocation;
      } else if (bigLogo && bigLogo.fileLocation) {
        return bigLogo.fileLocation;
      } else {
        return null;
      }
    },
    hideTopImage() {
      const { url } = this.contentShare || {};
      return url && ((url.includes('www.youtube.com') || url.includes('youtu.be')) || url.includes('vimeo'));
    },
  },
  methods: {
    async trigger() {
      const { contentShare, shareCode: contentShareCode } = this;
      this.$assert(contentShare && contentShare.id, new Error('Expected contentShare to exist'));

      const getProperty = (...getters) => {
        if (getters.length) {
          try {
            const getter = getters.shift();
            return getter() || getProperty(...getters) || null;
          } catch (err) {
            return getProperty(...getters) || null;
          }
        } else {
          return null;
        }
      };

      const { id, url, content } = contentShare;

      console.log('CONTENT SHARE: ', contentShare);

      const logVisited = {
        contentShare: id === contentShareCode ? { id } : { shareCode: contentShareCode },
        user: id !== contentShareCode ? { contentShareCode } : undefined,
        url,
        acceptLanguage: getProperty(() => window.navigator.userLanguage, () => window.navigator.language) || undefined,
        referer: getProperty(() => document.referrer) || undefined,
        userAgent: getProperty(() => window.navigator.userAgent) || undefined,
      };

      if (this.$route && this.$route.params) {
        const { eventID } = this.$route.params;
        if (eventID) {
          logVisited.event = { id: eventID };
        }
      }

      const captureQueryKeys = [ 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign' ];
      const queryString = qs.parse(getProperty(() => window.location.search) || '');
      for (const key in queryString) {
        if (queryString.hasOwnProperty(key) && !logVisited.hasOwnProperty(key) && captureQueryKeys.includes(key)) {
          logVisited[key] = queryString[key];
        }
      }

      try {
        await captureLog('CONTENT_SHARE_VISITED', logVisited);
      } catch (err) {
        this.$log.error(err);
      }

      const { redirect } = this.$route.query;
      if (redirect !== 'no' && url && url.length && (!content || !content.length)) {
        const queryExtension = window.location.href.split('?')[1] ? `?${window.location.href.split('?')[1]}` : '';
        console.log(queryExtension);
        setTimeout(() => {
          this.$log.info(`Redirecting to ${this.contentShare.url}${queryExtension}`);
          window.location = `${this.contentShare.url}${queryExtension}`;
        }, 500);
      } else if ((content && content.length) || !url || !url.length) {
        this.$log.info(`Has content, no need to redirect to ${this.contentShare.url}`);
      } else {
        this.$log.info(`Should have redirected to ${this.contentShare.url}`);
      }
    },
    createJobShareUrl({ shareCode }) {
      let prefix = '/r/';
      if (this.eventID) {
        prefix = `/e/r/${this.eventID}/`;
      }
      return `${this.origin}${prefix}${shareCode}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/content-share/ShareShow.vue